// Общие стили модальных окон в аркадной теме.
export const MODAL_CARD_CLASS = "modal-card-dark text-gray-800";
export const MODAL_HEADER_CLASS = "arcade-title text-gray-900";
export const MODAL_SUBHEADER_CLASS = "text-gray-700";
export const MODAL_PRIMARY_BUTTON_CLASS = "app-btn-primary";
export const MODAL_SECONDARY_BUTTON_CLASS = "app-btn-secondary";
export const MODAL_INNER_CARD_CLASS = "arcade-card text-gray-800";
export const MODAL_INNER_TEXT_CLASS = "text-gray-700";
